var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.293H3C2.86614 22.293 2.75 22.1768 2.75 22.043C2.75 21.9091 2.86614 21.793 3 21.793H21C21.1339 21.793 21.25 21.9091 21.25 22.043C21.25 22.1768 21.1339 22.293 21 22.293Z",
    fill: "#13181B",
    stroke: "#AEBCC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.92285H5.6C5.87713 8.92285 6.1 9.14225 6.1 9.42285V18.0429C6.1 18.3167 5.87386 18.5429 5.6 18.5429H4C3.72614 18.5429 3.5 18.3167 3.5 18.0429V9.42285C3.5 9.14899 3.72614 8.92285 4 8.92285Z",
    fill: "#13181B",
    stroke: "#AEBCC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 5.7334H12.7992C13.0731 5.7334 13.2992 5.95954 13.2992 6.2334V18.0434C13.2992 18.3173 13.0731 18.5434 12.7992 18.5434H11.1992C10.9254 18.5434 10.6992 18.3173 10.6992 18.0434V6.2334C10.6992 5.95954 10.9254 5.7334 11.1992 5.7334Z",
    fill: "#13181B",
    stroke: "#AEBCC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 2.04297H18.4004C17.8504 2.04297 17.4004 2.49297 17.4004 3.04297V18.043C17.4004 18.593 17.8504 19.043 18.4004 19.043H20.0004C20.5504 19.043 21.0004 18.593 21.0004 18.043V3.04297C21.0004 2.49297 20.5504 2.04297 20.0004 2.04297Z",
    fill: "#AEBCC6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.5e4be862c43ccb83bdbc00b200fb5236.svg";
export { ForwardRef as ReactComponent };